<template>
    <div class="flex items-center">
        <div class="project-company-avatar flex">
            <div class="project-company-avatar-container rounded-full">
                <span
                    v-if="!photoUrl"
                >{{(consultant) | getFirstLetter}}</span>
                <img v-else :src="photoUrl" alt />
        </div>
    </div>
    <div class="flex-1">
        {{consultant}}
    </div>
</div>
</template>

<script>
    export default {
    data() {
    return {
    photoUrl: null,
      consultant: null
};
},
    beforeMount() {
    this.photoUrl = this.params.data.photoUrl;
    this.consultant = this.params.data.consultant;
}

};
</script>
